// src/services/api/base.ts
import { apiClient } from './apiClient';

// Generic CRUD service factory for resources with an `id` field
// When `project` is provided, URLs become /api/{project}/{locale}/{resource}
export function createApiService<T extends { id: string }>(
  resourcePath: string,
  project?: string
) {
  const prefix = project ? `/api/${project}` : '/api';

  return {
    getAll: async (locale = 'en'): Promise<T[]> => {
      const response = await apiClient.get(
        `${prefix}/${locale}/${resourcePath}.json`
      );
      return response.data.items || [];
    },

    getOne: async (id: string, locale = 'en'): Promise<T> => {
      const response = await apiClient.get(
        `${prefix}/${locale}/${resourcePath}/${id}`
      );
      return response.data;
    },

    create: async (data: Omit<T, 'id'>, locale = 'en'): Promise<T> => {
      const response = await apiClient.post(
        `${prefix}/${locale}/${resourcePath}.json`,
        { ...data, id: 'placeholder' }
      );
      return response.data;
    },

    update: async (id: string, data: T, locale = 'en'): Promise<T> => {
      const response = await apiClient.put(
        `${prefix}/${locale}/${resourcePath}/${id}`,
        data
      );
      return response.data;
    },

    delete: async (id: string, locale = 'en'): Promise<void> => {
      await apiClient.delete(`${prefix}/${locale}/${resourcePath}/${id}`);
    },

    updateOrder: async (order: string[], locale = 'en'): Promise<void> => {
      await apiClient.put(`${prefix}/${locale}/${resourcePath}/order`, order);
    },
  };
}
